import React, { useEffect, useState } from 'react';
import { getUserById, updateUser } from '../../service/user';

// Material-UI Components
import {
	Box, Button, Card, CardContent, Container, Dialog, DialogActions,
	DialogContent, DialogTitle, Divider, Grid, IconButton, Paper, Snackbar, TextField, Typography,
	useTheme, Avatar, CircularProgress, FormControl, InputLabel,
	Select, MenuItem,
	Chip,
	Tooltip,
	Stack,
} from '@mui/material';
import {
	ArrowBack as ArrowBackIcon,
	Person as PersonIcon,
	Close as CloseIcon,
	Check as CheckIcon,
	Warning as WarningIcon,
	MailOutline as MailOutlineIcon,
} from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { sendEmailVerification, sendPhoneOTP, verifyPhoneOTP } from '../../service/profile';
import SendIcon from "@mui/icons-material/Send";
import NearMeIcon from "@mui/icons-material/NearMe";
import AddIcon from '@mui/icons-material/Add';

const Profile = () => {
	const theme = useTheme();
	const user = JSON.parse(localStorage?.getItem("user"));
	const navigate = useNavigate();

	const [openProfileDialog, setOpenProfileDialog] = useState(false);
	const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
	const [loading, setLoading] = useState(true);
	const [showVerificationModal, setShowVerificationModal] = useState(false);
	const [sendingVerification, setSendingVerification] = useState(false);
	const [showOtpDialog, setShowOtpDialog] = useState(false);
	const [otp, setOtp] = useState(["", "", "", ""]);
	const [phoneError, setPhoneError] = useState('');
	const [profileFormData, setProfileFormData] = useState({
		name: '',
		email: '',
		phone: '',
		is_email_verified: '',
		is_phone_verified: '',
		address: '',
		age: '',
		yearOfBirth: '',
		gender: '',
		marital_status: '',
		userData: '',
		created_at: ''
	});
	const [draftFormData, setDraftFormData] = useState(profileFormData);

	const isProfileFormValid =
		draftFormData.name.trim() !== '' &&
		draftFormData.email.trim() !== '' &&
		/^\d{10}$/.test(draftFormData.phone.trim());

	const [originalPhone, setOriginalPhone] = useState('');

	// useEffect(() => {
	// 	const fetchUser = async () => {
	// 		try {
	// 			const userId = 1915; // replace with the ID you want
	// 			const user = await getUserById(userId);
	// 			console.log("Fetched user:", user.user);
	// 		} catch (err) {
	// 			console.error("Failed to fetch user:", err);
	// 		}
	// 	};

	// 	fetchUser();
	// }, []);

	// Fetch user data
	const fetchUser = async () => {
		try {
			const userData = await getUserById(user?.id);
			console.log("Fetched user:", userData);

			if (
				userData?.is_email_verified === true &&
				userData?.is_phone_verified === true
			) {
				if (user && user.status !== "verified") {
					const updatedUser = {
						...user,
						status: "verified",
						is_email_verified: true,
						is_phone_verified: true,
					};

					localStorage.setItem("user", JSON.stringify(updatedUser));
					console.log("Local user status updated to verified ✅");
				}
			}

			setProfileFormData({
				name: userData?.name || '',
				email: userData?.email || '',
				phone: userData?.phone || '',
				is_email_verified: userData?.is_email_verified || '',
				is_phone_verified: userData?.is_phone_verified || '',
				address: userData?.address || '',
				age: userData?.age ? user?.age.toString() : '',
				yearOfBirth: '', // not in API, optional
				gender: userData?.gender || '',
				marital_status: userData?.marital_status || '',
				account_id: userData?.account_id || '',
				created_at: userData?.created_at || ''
			});
			setOriginalPhone(userData?.phone || '');
		} catch (err) {
			console.error("Failed to fetch user:", err);
		}
	};

	useEffect(() => {
		fetchUser();
	}, [user?.id]);

	// const handleEditProfile = () => {
	// 	setOpenProfileDialog(true);
	// };

	const handleEditProfile = () => {
		setDraftFormData(profileFormData); // snapshot current saved data into the draft
		setPhoneError('');
		setOpenProfileDialog(true);
	};

	const handleSendVerification = async () => {
		if (!profileFormData.email) return;

		try {
			setSendingVerification(true);

			const res = await sendEmailVerification(profileFormData.email);

			if (res.success) {
				setShowVerificationModal(true);
			} else {
				console.error(res.message);
			}

		} catch (err) {
			console.error("Verification failed:", err.message || err);
		} finally {
			setSendingVerification(false);
		}
	};

	// const handleSaveProfile = async () => {
	// 	try {
	// 		const phone = profileFormData.phone.trim();

	// 		// ✅ Phone validation
	// 		const phoneRegex = /^\d{10}$/;

	// 		if (!phoneRegex.test(phone)) {
	// 			setPhoneError("Enter a valid 10-digit phone number");
	// 			return;
	// 		}

	// 		const payload = {
	// 			name: profileFormData.name,
	// 			email: profileFormData.email,
	// 			phone: phone,
	// 			gender: profileFormData.gender,
	// 		};

	// 		// Reset verification if phone changed
	// 		if (phone !== originalPhone && originalPhone !== '') {
	// 			payload.is_phone_verified = 0;
	// 		}

	// 		console.log("Sending payload to API:", payload);

	// 		const response = await updateUser(user?.id, payload);

	// 		window.alert("Profile updated successfully");

	// 		if (phone !== originalPhone && originalPhone !== '') {
	// 			setProfileFormData(prev => ({
	// 				...prev,
	// 				is_phone_verified: false
	// 			}));
	// 			setOriginalPhone(phone);
	// 		}

	// 		setOpenProfileDialog(false);
	// 		fetchUser();

	// 	} catch (error) {
	// 		console.error("Failed to update profile:", error);
	// 		window.alert("Failed to update profile");
	// 	}
	// };

	const handleSaveProfile = async () => {
		try {
			const phone = draftFormData.phone.trim();
			const phoneRegex = /^\d{10}$/;

			if (!phoneRegex.test(phone)) {
				setPhoneError("Enter a valid 10-digit phone number");
				return;
			}

			const payload = {
				name: draftFormData.name,
				email: draftFormData.email,
				phone: phone,
				gender: draftFormData.gender,
			};

			if (phone !== originalPhone && originalPhone !== '') {
				payload.is_phone_verified = 0;
			}

			await updateUser(user?.id, payload);

			window.alert("Profile updated successfully");

			setOpenProfileDialog(false);
			fetchUser(); // re-fetch to refresh profileFormData from the server — this is what updates the card

		} catch (error) {
			console.error("Failed to update profile:", error);
			window.alert("Failed to update profile");
		}
	};

	const handleSendOTP = async () => {
		try {

			const res = await sendPhoneOTP(
				user.id,
				Number(profileFormData.phone)
			);

			if (res.success) {
				setShowOtpDialog(true);
			}

		} catch (err) {
			console.error("Failed to send OTP:", err);
		}
	};

	const handleResendOTP = async () => {
		try {

			const res = await sendPhoneOTP(
				user.id,
				Number(profileFormData.phone)
			);

			if (res.success) {
				console.log("OTP resent successfully");
			}

		} catch (err) {
			console.error("Resend OTP failed:", err);
		}
	};

	const handleOtpChange = (value, index) => {
		if (!/^[0-9]?$/.test(value)) return;

		const newOtp = [...otp];
		newOtp[index] = value;
		setOtp(newOtp);

		// Auto focus next input
		if (value && index < 3) {
			document.getElementById(`otp-${index + 1}`).focus();
		}
	};

	const handleVerifyOTP = async () => {
		try {

			const finalOtp = otp.join(""); // ["1","2","3","4"] -> "1234"

			const res = await verifyPhoneOTP(user.id, finalOtp);

			if (res.success) {
				setShowOtpDialog(false);

				// optional: update UI instantly
				setProfileFormData(prev => ({
					...prev,
					is_phone_verified: true
				}));
				fetchUser();
			}

		} catch (err) {
			console.error("OTP verification failed:", err);
		}
	};

	// const handleSaveProfile = async () => {
	// 	try {
	// 		if (!userId) {
	// 			showSnackbar('User ID not found. Please login again.', 'error');
	// 			return;
	// 		}

	// 		// 🛠️ Call API
	// 		const updatedUser = await updateUser(userId, profileFormData);

	// 		showSnackbar('Profile updated successfully', 'success');
	// 		setOpenProfileDialog(false);

	// 		fetchUser();

	// 	} catch (error) {
	// 		console.error("Profile update failed:", error);
	// 		const errorMsg = error?.message || error?.error || "Failed to update profile";
	// 		showSnackbar(errorMsg, 'error');
	// 	}
	// };

	const showSnackbar = (message, severity) => {
		setSnackbar({ open: true, message, severity });
	};

	const handleCloseSnackbar = () => {
		setSnackbar({ ...snackbar, open: false });
	};

	// Avatar with initials
	const getInitials = (name) => {
		return name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : '';
	};

	// if (loading) {
	// 	return (
	// 		<Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
	// 			<CircularProgress />
	// 		</Box>
	// 	);
	// }
	console.log("profileFormData.name", profileFormData.name)

	return (
		<Box sx={{ background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>
			<Container maxWidth="lg" sx={{ py: 4 }}>
				{/* Header */}
				<Box sx={{ mb: 4 }}>

					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, justifyContent: "space-between" }}>
						<Typography variant="h6" sx={{ fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
							My Profile
						</Typography>
						<IconButton
							onClick={() => navigate(-1)}
							sx={{
								backgroundColor: '#F0F5FF',
								width: 40,
								height: 40,
								borderRadius: '50%',
								color: '#0B2D6B',
								'&:hover': {
									backgroundColor: '#E0EBFF'
								}
							}}
						>
							<ArrowBackIcon />
						</IconButton>
					</Box>
				</Box>

				<Card
					sx={{
						mb: 4,
						borderRadius: 4,
						boxShadow: 4,
						overflow: 'hidden',
						background: 'linear-gradient(to bottom, #f9f9f9, #ffffff)',
					}}
				>
					<Box
						sx={{
							p: 4,
							py: 2,
							display: 'flex',
							alignItems: 'center',
							gap: 3,
						}}
					>
						<Avatar
							sx={{
								width: 70,
								height: 70,
								fontSize: '1.5rem',
								border: '4px solid rgba(255,255,255,0.7)',
								background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)'
							}}
						>
							{getInitials(profileFormData.name)}
						</Avatar>

						{/* <Box sx={{
							display: "flex",
							alignItems: "flex-start",
							width: "100%",
							gap: 3,
							position: "relative",
							pt: 2
						}}>

							<Box sx={{
								display: "flex",
								flexDirection: "column",
								flexGrow: 1,
								mt: 1
							}}>
								<Typography variant="h5">
									{profileFormData.name}
								</Typography>
								<Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
									Member since{" "}
									{new Date(profileFormData.created_at).toLocaleDateString("en-GB", {
										day: "numeric",
										month: "short",
										year: "numeric",
									})}
								</Typography>
							</Box>

							<Button
								variant="contained"
								onClick={handleEditProfile}
								sx={{
									textTransform: "none",
									borderRadius: 3,
									px: 3,
									position: "absolute",
									top: 0,
									right: 0,
									background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)'
								}}
							>
								Edit
							</Button>
						</Box> */}
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								width: "100%",
								gap: 2,
								minWidth: 0,
								pt: 2
							}}
						>
							{/* User Name and Member Since */}
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									flexGrow: 1,
									minWidth: 0,
									overflowWrap: "anywhere"
								}}
							>
								<Typography
									variant="h5"
									sx={{
										fontSize: { xs: "1.1rem", sm: "1.5rem" },
										fontWeight: 500
									}}
								>
									{profileFormData.name}
								</Typography>

								<Typography
									variant="subtitle1"
									sx={{
										opacity: 0.9,
										fontSize: { xs: "0.8rem", sm: "1rem" }
									}}
								>
									Member since{" "}
									{new Date(profileFormData.created_at).toLocaleDateString("en-GB", {
										day: "numeric",
										month: "short",
										year: "numeric",
									})}
								</Typography>
							</Box>

							{/* Edit Button */}
							<Button
								variant="contained"
								onClick={handleEditProfile}
								sx={{
									textTransform: "none",
									borderRadius: 3,
									px: { xs: 2, sm: 3 },
									flexShrink: 0,
									alignSelf: "flex-start",
									background: "linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)"
								}}
							>
								Edit
							</Button>
						</Box>
					</Box>

					<Divider sx={{ mb: 4 }} />

					<CardContent sx={{ p: 4, pt: 0 }}>
						<Grid container spacing={4}>
							<Grid item xs={12} md={6}>
								<Paper
									elevation={0}
									sx={{
										p: 3,
										borderRadius: 3,
										bgcolor: 'white',
										border: '1px solid #e0e0e0',
									}}
								>
									<Typography variant="h6" color="primary" gutterBottom>
										<PersonIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
										Contact Information
									</Typography>

									<Box sx={{ mb: 2 }}>
										<Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
											<Typography variant="caption" color="text.secondary">
												Email Address
											</Typography>

											{profileFormData.is_email_verified !== undefined && (
												<>
													{/* Verified / Unverified Chip */}
													<Chip
														label={profileFormData.is_email_verified ? "Verified" : "Unverified"}
														size="small"
														sx={{
															height: 20,
															fontSize: '0.65rem',
															bgcolor: profileFormData.is_email_verified ? '#d1fae5' : '#fee2e2',
															color: profileFormData.is_email_verified ? '#065f46' : '#b91c1c',
															fontWeight: 500,
															borderRadius: '8px',
														}}
													/>

													{/* If NOT verified → Show Email Chip with Tooltip */}
													{!profileFormData.is_email_verified && (
														<Tooltip title="Send Verification Link" arrow>
															<IconButton
																size="small"
																sx={{
																	height: 22,
																	width: 22,
																	bgcolor: '#e0e7ff',
																	color: '#3730a3',
																	borderRadius: '6px',
																	'&:hover': {
																		bgcolor: '#c7d2fe',
																	},
																}}
																onClick={handleSendVerification}
																disabled={sendingVerification}
															>
																<NearMeIcon sx={{ fontSize: 12 }} />
															</IconButton>
														</Tooltip>
													)}
												</>
											)}
										</Box>
										<Typography variant="body1" fontWeight="500">
											{profileFormData.email || 'Not provided'}
										</Typography>
									</Box>

									<Box sx={{ mb: 2 }}>
										<Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
											<Typography variant="caption" color="text.secondary">
												Phone Number
											</Typography>
											{!profileFormData.phone && (
												<Tooltip title="Add Phone Number" arrow>
													<IconButton
														size="small"
														// onClick={() => setOpenProfileDialog(true)}
														onClick={() => {
															setDraftFormData(profileFormData);
															setOpenProfileDialog(true);
														}}
														sx={{
															height: 22,
															width: 22,
															bgcolor: '#e0f2fe',
															color: '#0369a1',
															borderRadius: '6px',
															padding: 0,
															'&:hover': {
																bgcolor: '#bae6fd',
															}
														}}
													>
														<AddIcon sx={{ fontSize: 14 }} />
													</IconButton>
												</Tooltip>
											)}
											{profileFormData?.phone && (
												<>
													{profileFormData.is_phone_verified !== undefined && (
														<Chip
															label={profileFormData.is_phone_verified ? "Verified" : "Unverified"}
															size="small"
															sx={{
																height: 20,
																fontSize: '0.65rem',
																bgcolor: profileFormData.is_phone_verified ? '#d1fae5' : '#fee2e2',
																color: profileFormData.is_phone_verified ? '#065f46' : '#b91c1c',
																fontWeight: 500,
																borderRadius: '8px',
																textTransform: 'capitalize'
															}}
														/>
													)}

													{!profileFormData.is_phone_verified && (
														<Tooltip title="Send Verification Link" arrow>
															<IconButton
																size="small"
																onClick={handleSendOTP}
																sx={{
																	height: 22,
																	width: 22,
																	bgcolor: '#e0e7ff',
																	color: '#3730a3',
																	borderRadius: '6px',
																	padding: 0,
																	'&:hover': {
																		bgcolor: '#c7d2fe',
																	}
																}}
															>
																<NearMeIcon sx={{ fontSize: 12 }} />
															</IconButton>
														</Tooltip>
													)}
												</>
											)}
										</Box>
										<Typography variant="body1" fontWeight="500">
											{profileFormData.phone || 'Not provided'}
										</Typography>
									</Box>

									{/* <Box>
										<Typography variant="caption" color="text.secondary">
											Address
										</Typography>
										<Typography variant="body1" fontWeight="500">
											{profileFormData.address || 'Not provided'}
										</Typography>
									</Box> */}
								</Paper>
							</Grid>

							<Grid item xs={12} md={6}>
								<Paper
									elevation={0}
									sx={{
										p: 3,
										borderRadius: 3,
										bgcolor: 'white',
										border: '1px solid #e0e0e0',
									}}
								>

									<Typography variant="h6" color="primary" gutterBottom>
										<PersonIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
										Personal Details
									</Typography>

									<Grid container spacing={2} mb={3}>
										{/* <Grid item xs={6}>
											<Paper
												elevation={0}
												sx={{
													p: 3,
													textAlign: 'center',
													borderRadius: 3,
													bgcolor: 'grey.50',
													border: '1px solid #e0e0e0',
												}}
											>
												<Typography variant="h5" color="primary" fontWeight="bold">
													{profileFormData.age || '--'}
												</Typography>
												<Typography variant="caption" color="text.secondary">
													Years Old
												</Typography>
											</Paper>
										</Grid> */}

										<Grid item xs={12}>
											<Paper
												elevation={0}
												sx={{
													p: 3,
													textAlign: 'center',
													borderRadius: 3,
													bgcolor: 'grey.50',
													border: '1px solid #e0e0e0',
												}}
											>
												<Typography variant="h5" color="primary" fontWeight="bold">
													{profileFormData.gender
														? profileFormData.gender.charAt(0).toUpperCase() +
														profileFormData.gender.slice(1)
														: '--'}
												</Typography>
												<Typography variant="caption" color="text.secondary">
													Gender
												</Typography>
											</Paper>
										</Grid>
									</Grid>

									{/* <Box>
										<Typography variant="caption" color="text.secondary">
											Marital Status
										</Typography>
										<Typography variant="body1" fontWeight="500">
											{profileFormData.marital_status
												? profileFormData.marital_status.charAt(0).toUpperCase() +
												profileFormData.marital_status.slice(1)
												: 'Not specified'}
										</Typography>
									</Box> */}
								</Paper>
							</Grid>
						</Grid>
					</CardContent>
				</Card>

				{/* Edit Profile Dialog */}
				<Dialog
					open={openProfileDialog}
					onClose={() => setOpenProfileDialog(false)}
					maxWidth="sm"
					fullWidth
				>
					<DialogTitle sx={{ background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Edit Profile</DialogTitle>
					<IconButton
						aria-label="close"
						onClick={() => setOpenProfileDialog(false)}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
					<DialogContent dividers>
						<Grid container spacing={2}>
							<Grid item xs={12} md={6}>
								{/* <TextField
									label="Full Name"
									fullWidth
									margin="normal"
									required
									value={profileFormData.name}
									onChange={(e) => setProfileFormData({ ...profileFormData, name: e.target.value })}
								/> */}
								<TextField
									label="Full Name"
									fullWidth
									margin="normal"
									required
									value={draftFormData.name}
									onChange={(e) => setDraftFormData({ ...draftFormData, name: e.target.value })}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								{/* <TextField
									label="Email Address"
									type="email"
									fullWidth
									margin="normal"

									required
									value={profileFormData.email}
									disabled
									onChange={(e) => setProfileFormData({ ...profileFormData, email: e.target.value })}
								/> */}
								<TextField
									label="Email Address"
									type="email"
									fullWidth
									margin="normal"
									required
									value={draftFormData.email}
									disabled
									onChange={(e) => setDraftFormData({ ...draftFormData, email: e.target.value })}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								{/* <TextField
									label="Phone Number"
									type="tel"
									fullWidth
									margin="normal"
									required
									value={profileFormData.phone}
									error={!!phoneError}
									helperText={phoneError}
									onChange={(e) => {
										const value = e.target.value.replace(/\s/g, ''); // remove spaces
										setProfileFormData({ ...profileFormData, phone: value });
										setPhoneError(''); // clear error while typing
									}}
									inputProps={{ maxLength: 10 }}
								/> */}
								<TextField
									label="Phone Number"
									type="tel"
									fullWidth
									margin="normal"
									required
									value={draftFormData.phone}
									error={!!phoneError}
									helperText={phoneError}
									onChange={(e) => {
										const value = e.target.value.replace(/\s/g, '');
										setDraftFormData({ ...draftFormData, phone: value });
										setPhoneError('');
									}}
									inputProps={{ maxLength: 10 }}
								/>
							</Grid>
							{/* <Grid item xs={12} md={6}>
								<TextField
									label="Age"
									type="number"
									fullWidth
									margin="normal"
									value={profileFormData.age}
									onChange={(e) => setProfileFormData({ ...profileFormData, age: e.target.value })}
									inputProps={{ min: 1, max: 120 }}
								/>
							</Grid> */}
							<Grid item xs={12} md={6}>
								<FormControl fullWidth margin="normal">
									<InputLabel>Gender</InputLabel>
									<Select
										// value={profileFormData.gender}
										value={draftFormData.gender}
										label="Gender"
										// onChange={(e) => setProfileFormData({ ...profileFormData, gender: e.target.value })}
										onChange={(e) => setDraftFormData({ ...draftFormData, gender: e.target.value })}

									>
										<MenuItem value="">Select gender</MenuItem>
										<MenuItem value="male">Male</MenuItem>
										<MenuItem value="female">Female</MenuItem>
										<MenuItem value="other">Other</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							{/* <Grid item xs={12} md={6}>
								<FormControl fullWidth margin="normal">
									<InputLabel>Marital Status</InputLabel>
									<Select
										value={profileFormData.marital_status}
										label="Marital Status"
										onChange={(e) => setProfileFormData({ ...profileFormData, marital_status: e.target.value })}
									>
										<MenuItem value="">Select status</MenuItem>
										<MenuItem value="single">Single</MenuItem>
										<MenuItem value="married">Married</MenuItem>
										<MenuItem value="divorced">Divorced</MenuItem>
										<MenuItem value="widowed">Widowed</MenuItem>
									</Select>
								</FormControl>
							</Grid> */}
							{/* <Grid item xs={12}>
								<TextField
									label="Address"
									multiline
									rows={2}
									fullWidth
									margin="normal"
									value={profileFormData.address}
									onChange={(e) => setProfileFormData({ ...profileFormData, address: e.target.value })}
								/>
							</Grid> */}
						</Grid>
					</DialogContent>
					<DialogActions sx={{ p: 2 }}>
						<Button onClick={() => setOpenProfileDialog(false)}>Cancel</Button>
						{/* <Button
							onClick={handleSaveProfile}
							variant="contained"
							disableElevation
							sx={{ background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', color: 'white' }}
						>
							Save Changes
						</Button> */}
						<Button
							onClick={handleSaveProfile}
							variant="contained"
							disableElevation
							disabled={!isProfileFormValid}
							sx={{
								background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
								color: 'white',
								'&.Mui-disabled': {
									background: '#D1D5DB',
									color: '#9CA3AF',
									cursor: 'not-allowed'
								}
							}}
						>
							Save Changes
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={showVerificationModal}
					onClose={() => setShowVerificationModal(false)}
					maxWidth="xs"
					fullWidth
					BackdropProps={{
						sx: {
							backgroundColor: 'rgba(0, 0, 0, 0.7)',
							backdropFilter: 'blur(8px)',
						}
					}}
					PaperProps={{
						sx: {
							borderRadius: 4,
							p: 3,
							boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
						}
					}}
				>
					<DialogContent sx={{ p: 0 }}>
						<Box sx={{ textAlign: 'center', mb: 4 }}>
							<Typography
								sx={{
									fontSize: 20,
									fontWeight: 700,
									background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
									WebkitBackgroundClip: 'text',
									WebkitTextFillColor: 'transparent',
									backgroundClip: 'text',
								}}
							>
								Email Verification
							</Typography>
							<Typography
								sx={{
									fontSize: 13,
									color: '#64748B',
									mt: 1
								}}
							>
								We've sent a verification link to your email. Please verify your email address to access all features.
							</Typography>
						</Box>
						<Stack spacing={2}>
							<Button
								fullWidth
								variant="contained"
								onClick={() => {
									setShowVerificationModal(false);
									// setShowEchoHome(true);
									// localStorage.setItem("showEchoHome", "true");
								}}
								sx={{
									py: 1.5,
									borderRadius: 2,
									textTransform: "none",
									fontWeight: 600,
									background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
									color: '#ffffff',
									'&:hover': {
										background: 'linear-gradient(135deg, #16a34a, #0d9488, #7c3aed)',
									}
								}}
							>
								Proceed
							</Button>
						</Stack>
					</DialogContent>
				</Dialog>

				<Dialog
					open={showOtpDialog}
					onClose={() => setShowOtpDialog(false)}
					maxWidth="xs"
					fullWidth
					BackdropProps={{
						sx: {
							backgroundColor: 'rgba(0, 0, 0, 0.7)',
							backdropFilter: 'blur(8px)',
						}
					}}
					PaperProps={{
						sx: {
							borderRadius: 4,
							p: 3,
						}
					}}
				>
					<DialogContent sx={{ p: 0 }}>

						{/* Title */}
						<Box sx={{ textAlign: 'center', mb: 3 }}>
							<Typography
								sx={{
									fontSize: 18,
									fontWeight: 700,
								}}
							>
								OTP sent to your phone number
							</Typography>
							<Typography sx={{ fontSize: 12, color: '#64748B', mt: 1 }}>
								Enter the 4-digit code sent to {profileFormData.phone}
							</Typography>
						</Box>

						{/* OTP Inputs */}
						<Stack direction="row" spacing={2} justifyContent="center" mb={1}>
							{otp.map((digit, index) => (
								<TextField
									key={index}
									id={`otp-${index}`}
									value={digit}
									onChange={(e) => handleOtpChange(e.target.value, index)}
									inputProps={{
										maxLength: 1,
										style: {
											textAlign: 'center',
											fontSize: '20px',
											padding: '10px',
										}
									}}
									sx={{
										width: 50,
										'& .MuiOutlinedInput-root': {
											borderRadius: 2,
										}
									}}
								/>
							))}
						</Stack>

						{/* Resend OTP */}
						<Box textAlign="right" mb={1}>
							<Button
								size="small"
								sx={{
									textTransform: "none",
									fontSize: 12
								}}
								onClick={handleResendOTP}
							>
								Resend OTP
							</Button>
						</Box>

						{/* Verify Button */}
						<Button
							fullWidth
							variant="contained"
							onClick={handleVerifyOTP}
							sx={{
								py: 1.5,
								borderRadius: 2,
								textTransform: "none",
								fontWeight: 600,
								background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
								color: '#ffffff',
								'&:hover': {
									background: 'linear-gradient(135deg, #16a34a, #0d9488, #7c3aed)',
								}
							}}
						>
							Verify OTP
						</Button>

					</DialogContent>
				</Dialog>

				{/* Snackbar */}
				<Snackbar
					open={snackbar.open}
					autoHideDuration={3000}
					onClose={handleCloseSnackbar}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							bgcolor: 'background.paper',
							color: snackbar.severity === 'error' ? 'error.main' : 'success.main',
							p: 2,
							borderRadius: 1,
							boxShadow: 3,
							minWidth: 300,
							borderLeft: `4px solid ${snackbar.severity === 'error' ? theme.palette.error.main : theme.palette.success.main}`,
						}}
					>
						{snackbar.severity === 'error' ? (
							<WarningIcon sx={{ mr: 1 }} />
						) : (
							<CheckIcon sx={{ mr: 1 }} />
						)}
						<Typography variant="body2">{snackbar.message}</Typography>
						<IconButton
							size="small"
							aria-label="close"
							color="inherit"
							onClick={handleCloseSnackbar}
							sx={{ ml: 'auto' }}
						>
							<CloseIcon fontSize="small" />
						</IconButton>
					</Box>
				</Snackbar>
			</Container>
		</Box>
	);
};

export default Profile;
